import PropTypes from 'prop-types';

import mastercardImg from '../../assets/img/mastercard.png';
import visaImg from '../../assets/img/visa.png';
import paypalImg from '../../assets/img/paypal.png';
import klarnaImg from '../../assets/img/klarna.png';
import sepaImg from '../../assets/img/sepa-sofort.png';

const CreditCardOption = ({
  paymentAccount,
  selectedPaymentOption,
  setSelectedPaymentOption,
}) => {
  const isSelected = paymentAccount.accountHolder === selectedPaymentOption;
  const bgColor = isSelected ? 'bg-pj-primary-400' : 'bg-pj-gray-500';
  const creditCardMask = `**** **** **** ${paymentAccount.accountNumber}`;

  const getIcon = () => {
    if (paymentAccount.paymentMethod === 'mc') {
      return mastercardImg;
    } if (paymentAccount.paymentMethod === 'visa') {
      return visaImg;
    }
    if (paymentAccount.paymentMethod === 'paypal') {
      return paypalImg;
    }
    if (paymentAccount.paymentMethod === 'klarna') {
      return klarnaImg;
    }
    if (paymentAccount.paymentMethod === 'sepadirectdebit') {
      return sepaImg;
    }

    return null;
  };

  const textStyle = isSelected
    ? 'text-pj-good-contrast font-bold'
    : 'text-black';

  return (
    <div
      className={`flex items-center gap-8 rounded-lg px-4 py-6 ${bgColor} ${textStyle}`}
      key={paymentAccount.accountHolder}
      role="button"
      tabIndex="0"
      onClick={() => setSelectedPaymentOption(paymentAccount.accountHolder)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          setSelectedPaymentOption(paymentAccount.accountHolder);
        }
      }}
    >
      <input
        className="hidden"
        type="radio"
        id={paymentAccount.accountHolder}
        name="paymentOption"
      />
      <div>
        <img src={getIcon()} alt={`${paymentAccount.accountHolder} icon`} />
      </div>

      <div className="flex flex-col gap-4 xxxs:flex-row">
        <label htmlFor={paymentAccount.accountHolder}>{paymentAccount.accountHolder}</label>
        <span>{creditCardMask}</span>
      </div>
    </div>
  );
};

CreditCardOption.propTypes = {
  paymentAccount: PropTypes.shape({
    accountNumber: PropTypes.string,
    accountHolder: PropTypes.string,
    expiryMonth: PropTypes.string,
    expiryYear: PropTypes.string,
    paymentMethod: PropTypes.string,
    payerEmail: PropTypes.string,
    isVirtual: PropTypes.bool,
    isActive: PropTypes.bool,
  }).isRequired,
  selectedPaymentOption: PropTypes.string,
  setSelectedPaymentOption: PropTypes.func.isRequired,
};

export default CreditCardOption;
